export const UPDATE_SEGMENT_ERROR = 'Segment update error';

export const TOGGLE_CLIPS_DIALOG_TITLE = 'Toggle all clips';

export const TOGGLE_CLIPS_DIALOG_SUBTITLE =
  'This setting will be applied to all clips included on this episode';
